/* eslint-disable no-negated-condition */
/* eslint-disable no-prototype-builtins */
import React from 'react';
import checkBox from 'Images/Checkbox_empty.svg';
import matchField from '../../helper';
import { ToAddColumn, Wrapper, Field } from './styled';
import { Icon } from '../../styled';
import { useSelector } from 'react-redux';
import { selectParsedCustomAttributes } from 'store/CustomAttributes/selectors';
import { useLocation } from 'react-router-dom';

const NotIncludedList = ({ fields, setFieldVisibility, entity, testIdPrefix }) => {
  const customFields = useSelector(selectParsedCustomAttributes);

  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const excludeCustom =
  location.pathname === '/hosts' ||
  location.pathname === '/services' ||
  location.pathname === '/workspaces' ||
  segments[0] === 'knowledge_base' ||

  (
    ['host', 'service'].includes(segments[0]) &&
    segments.length === 2
  ) ||

  (
    ['host', 'service'].includes(segments[0]) &&
    segments[segments.length - 1] === 'services'
  );

  const columnsNotIncluded = [
    ...Object.keys(fields)
      .filter((key) => fields[key].visible === false)
      .map((key) => ({ key, type: 'default' })),

    ...(!excludeCustom
      ? Object.keys(customFields)
        .filter((key) => {
          const fieldCustom = fields[`${key}_custom`];

          if (fields.hasOwnProperty(`${key}_custom`)) return false;
          if (fieldCustom?.visible === true) return false;

          return true;
        })
        .map((key) => ({ key, type: 'custom' }))
      : [])
  ].sort((a, b) => a.key.localeCompare(b.key));

  return (
    <Wrapper>
      {columnsNotIncluded.map(({ key, type }) => (
        <ToAddColumn
          key={ `context_menu_add_remove_column_${type}_${key}` }
          onClick={ (e) => {
            e.stopPropagation();
            setFieldVisibility(key, true, type);
          } }
          aria-label="Add Column"
          role="button"
          onKeyDown={ () => {} }
          type="button"
          tabIndex="0"
          data-testid={ testIdPrefix ? `${testIdPrefix}-column-item` : undefined }
          data-column-name={ key }
        >
          <Field>{matchField(key, entity, type)}</Field>
          <Icon src={ checkBox } />
        </ToAddColumn>
      ))}

    </Wrapper>
  );
};

export default NotIncludedList;
